import {
    ChevronLeftIcon,
    ChevronRightIcon,
    XMarkIcon,
} from "@heroicons/react/24/outline";
import clsx from "clsx";
import { useAtom } from "jotai";
import { sidebarOpenAtom } from "../state";
import { CollapseGlyph } from "./CollapseIcon";

export function ReturnHeader({
    backLink,
    className,
    isMobile,
    rightSidebar = false,
}: {
    backLink?: {
        label: string;
        onClick: () => void;
    };
    className?: string;
    isMobile?: boolean;
    rightSidebar?: boolean;
}) {
    const [sidebarOpen, setSidebarOpen] = useAtom(sidebarOpenAtom);

    return (
        <div
            className={clsx(
                "flex items-center py-1",
                rightSidebar ? "mb-4" : "mb-12 justify-between lg:mb-4",
                className,
            )}
        >
            {backLink && (
                <div
                    className="flex cursor-pointer items-center gap-2"
                    onClick={backLink.onClick}
                >
                    {rightSidebar ? (
                        <>
                            <span className="ui-element subdued">
                                {backLink.label}
                            </span>
                            <ChevronRightIcon
                                width={12}
                                height={12}
                                className="text-gray-400"
                            />
                        </>
                    ) : (
                        <>
                            <ChevronLeftIcon
                                width={12}
                                height={12}
                                className="text-gray-400"
                            />
                            <span className="ui-element subdued">
                                {backLink.label}
                            </span>
                        </>
                    )}
                </div>
            )}

            {!rightSidebar && (
                <button
                    type="button"
                    onClick={() => setSidebarOpen(!sidebarOpen)}
                    aria-label="Toggle sidebar"
                    className="collapse-menu-btn cursor-pointer focus:outline-none"
                >
                    {!isMobile ? (
                        <CollapseGlyph className="size-4 cursor-pointer" />
                    ) : (
                        <XMarkIcon className="size-6 cursor-pointer" />
                    )}
                </button>
            )}
        </div>
    );
}

export default ReturnHeader;
